/*******************************************************************************
 * Controller: itemOptionsController
 *
 * Controller for the options view.
 *******************************************************************************/
/* @ngInject */ export function ItemOptionsController(
  $scope,
  $timeout,
  Alert,
  AddChangeItemOptionMasterDialog,
  BooksSvc,
  BusyScreen,
  ItemAdminService,
  ItemAdminGridStates,
  OptionMasterTypes,
  SERVER,
  uiGridConstants
) {
  /*---------------------------------*/
  /* Show inactive options checkbox. */
  /*---------------------------------*/
  /** Inactive Options flag */ var mShowInactiveOptions = false;

  /*----------------------*/
  /* Product ID constant. */
  /*----------------------*/
  /** ASB Works product ID. */ var PID_ASBWORKS = 'ASB Works';

  /*--------*/
  /* Flags. */
  /*--------*/
  var optionDialogActive = false;
  var excludeGuestType = SERVER.productID != PID_ASBWORKS;

  /*-----------------------------------------*/
  /* template to add ng-dblClick to each row */
  /*-----------------------------------------*/
  var dblClickTemplate =
    '<div ng-dblclick="grid.appScope.changeOption(row.entity)" ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.colDef.name" class="ui-grid-cell" ui-grid-cell></div>';

  /*----------------------------------------------*/
  /* Template for the Actions column in the grid. */
  /*----------------------------------------------*/
  var actionsTemplate =
    '<div class="ui-grid-cell-contents ng-binding ng-scope"> ' +
    '<table><tr>' +
    '<td style="width:25px;"><span style="cursor:pointer;" class="glyphicon glyphicon-edit  csm-grid-space-target" title="Change Option" ng-click="grid.appScope.changeOption(row.entity)"></span></td>' +
    '<td style="width:25px;"><span style="cursor:pointer;" class="glyphicon glyphicon-trash csm-grid-space-target" title="Delete Option" ng-click="grid.appScope.deleteOption(row.entity)"></span></td>' +
    '</tr></table>' +
    '</div>';

  /*----------------------*/
  /* Options grid options */
  /*----------------------*/
  $scope.itemsOptionsGrid = {
    enableColumnMenus: false,
    enableRowSelection: true,
    enableFiltering: true,
    enableFullRowSelection: true,
    enableRowHeaderSelection: false,
    multiSelect: false,
    enableSelectAll: false,
    saveFilter: true,
    saveSort: true,
    rowTemplate: dblClickTemplate,
    enableHorizontalScrollbar: uiGridConstants.scrollbars.WHEN_NEEDED,
    enableVerticalScrollbar: uiGridConstants.scrollbars.WHEN_NEEDED,
    onRegisterApi: function (gridApi) {
      $scope.itemsOptionsGrid.api = gridApi;
    },
    data: [],
    columnDefs: [
      {
        field: 'name',
        minWidth: 170,
        maxWidth: 200,
        displayName: 'Name',
        cellClass: getInactiveCellClass
      },
      {
        field: 'type',
        minWidth: 250,
        displayName: 'Type',
        cellFilter: 'mapOptionTypes',
        cellClass: getInactiveCellClass,
        filter: {
          term: '',
          type: uiGridConstants.filter.SELECT,
          condition: uiGridConstants.filter.EXACT,
          selectOptions: OptionMasterTypes
        }
      },
      {
        field: 'values',
        displayName: 'Values',
        minWidth: 300,
        cellFilter: 'mapOptionValues',
        cellClass: getInactiveCellClass,
        cellTooltip: true
      },
      {
        field: 'active',
        minWidth: 91,
        maxWidth: 91,
        displayName: 'Active?',
        cellFilter: 'boolToString',
        cellClass: getInactiveCellClass,
        filter: {
          term: true,
          type: uiGridConstants.filter.SELECT,
          selectOptions: [
            { value: null, label: 'ALL' },
            { value: true, label: 'Y' },
            { value: false, label: 'N' }
          ]
        }
      },
      {
        appScope: $scope,
        cellTemplate: actionsTemplate,
        displayName: 'Actions',
        enableFiltering: false,
        enableSorting: false,
        field: 'actions',
        pinnedRight: true,
        minWidth: 75,
        width: 75
      }
    ]
  };

  /*****************************************************************************
   * addOption */
  /**
   * `Add Option` button click handler. Displays the dialog to add a new option
   * to the itemOptionMasterList.
   *****************************************************************************/
  $scope.addOption = function () {
    /*-------------------------*/
    /* Dialog is active, exit. */
    /*-------------------------*/
    if (optionDialogActive) return;

    /*------------------------------------*/
    /* Display dialog to add/change item. */
    /*------------------------------------*/
    optionDialogActive = true;
    AddChangeItemOptionMasterDialog.show(null, excludeGuestType)
      .then(function () {
        /*--------------------------------------*/
        /* Reload the list and update the grid. */
        /*--------------------------------------*/
        ItemAdminService.reloadOptions().then(function () {
          $scope.itemsOptionsGrid.data = ItemAdminService.getOptions();
        });
      })
      ['finally'](function () {
        optionDialogActive = false;
      });
  };

  /*****************************************************************************
   * changeOption */
  /**
   * Add a new option or change an existing option in the itemOptionMasterList.
   *
   * @param  option  Option to modify.
   *****************************************************************************/
  $scope.changeOption = function (option) {
    /*-------------------------*/
    /* Dialog is active, exit. */
    /*-------------------------*/
    if (optionDialogActive) return;

    /*--------------------------*/
    /* Nothing to modify, exit. */
    /*--------------------------*/
    if (!option) return;

    /*--------------------------------*/
    /* Display dialog to change item. */
    /*--------------------------------*/
    optionDialogActive = true;
    AddChangeItemOptionMasterDialog.show(option.id, excludeGuestType)
      .then(function () {
        /*--------------------------------------*/
        /* Reload the list and update the grid. */
        /*--------------------------------------*/
        ItemAdminService.reloadOptions().then(function () {
          $scope.itemsOptionsGrid.data = ItemAdminService.getOptions();
        });
      })
      ['finally'](function () {
        optionDialogActive = false;
      });
  };

  /*****************************************************************************
   * deleteOption */
  /**
   * Removes item option by id.
   *
   * @param  option  Option to delete.
   *****************************************************************************/
  $scope.deleteOption = function (option) {
    /*--------------------------------------------*/
    /* Nothing has been selected to remove. Exit. */
    /*--------------------------------------------*/
    if (!option) return;

    /*--------------------------------*/
    /* Confirm with user for removal. */
    /*--------------------------------*/
    Alert.confirm(
      'This action cannot be undone. Are you sure you want to remove Option: {0}?'.format(
        option.name
      )
    ).then(function () {
      /*-------------------------------------*/
      /* Remove option, if response from     */
      /* server is error, display to screen. */
      /*-------------------------------------*/
      BusyScreen.setBusy(true);
      ItemAdminService.dropItemOptionMaster(option.id)
        .then(
          function () {
            Alert.success('Item option successfully removed.');
            ItemAdminService.reloadOptions().then(function () {
              $scope.itemsOptionsGrid.data = ItemAdminService.getOptions();
            });
          },
          /*--------------------------------------------------*/
          /* Server responded with an error. Display to user. */
          /*--------------------------------------------------*/
          function (resp) {
            Alert.error(
              resp.parsedResponse.message() || 'Error deleting this option',
              'Failed to remove option.'
            );
          }
        )
        .finally(function () {
          BusyScreen.setBusy(false);
        });
    });
  };

  /*****************************************************************************
   * getInactiveCellClass */
  /**
   * Returns the CSS class name to be applied to the grid cell on inactive
   * items.
   *
   * @param  grid   ui-grid reference
   * @param  row    ui-grid row
   * @param  col    ui-grid column
   *
   * @return  String   CSS class name inactive or empty string.
   *****************************************************************************/
  function getInactiveCellClass(grid, row, col) {
    return !row.entity.active ? 'inactive' : '';
  }

  /*--------------------------------------------*/
  /* Link the grid state data and load the data */
  /*--------------------------------------------*/
  ItemAdminGridStates.options.init($scope.itemsOptionsGrid);

  $scope.itemsOptionsGrid.data = ItemAdminService.getOptions();
}
